module.exports = [
  // {path:"/login",redirect:"/login"},
  {
    path: "/login",
    name: "登录",
    component: () => import("../../components/auth/login.vue"),
  },
  {
    path: "/register",
    name: "注册",
    component: () => import("../../components/auth/register.vue"),
  },
  {
    path: "/loginProvider",
    name: "供应商登录",
    component: () => import("../../components/auth/loginforprovider.vue"),
  },
];
